import { API } from "../../../../common/api/constants";

// ПОЛУЧИТЬ СПИСОК ПРОДУКТОВ ПИТАНИЯ ПО НОМЕРУ ЗАКАЗА
export const GET_FOOD_PRODUCT_LIST = `${API}/order/orders/{order_id}/food_product_lists`; // GET

// ДОБАВИТЬ ПРОДУКТ ПИТАНИЯ В СПИСОК ПО НОМЕРУ ЗАКАЗА
export const ADD_FOOD_PRODUCT_TO_LIST = `${API}/order/orders/{order_id}/food_product_lists`; // POST

// УДАЛИТЬ ПРОДУКТ ПИТАНИЯ ИЗ СПИСКА
export const DELETE_FOOD_PRODUCT = `${API}/order/food_product_lists/{food_product_list_id}`; // DELETE

// УДАЛИТЬ ПРОДУКТ ПИТАНИЯ ИЗ СПИСКА
export const EDIT_FOOD_PRODUCT = `${API}/order/food_product_lists/{food_product_list_id}`; // PUT
